import moment from 'moment';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            latestPeriod: '=',
            hideForm: '&',
            period: '='
        },
        controller: ['$state', '$scope', 'PolicyService', '$window', '$q', 'ModalService', 'ViewModelService', 'GPA_PC_ENTRY_POINT', '$filter', '$stateParams', function ($state, $scope, PolicyService, $window, $q, ModalService, ViewModelService, GPA_PC_ENTRY_POINT, $filter, $stateParams) {
            var policyNumber = $stateParams.policyNumber;
            /**
            * Function to retrieve open changes by Policy Number
            * @params{String} - policyNumber
            * @returns{Object} - promise
            * @private
            **/
            var changePromise = PolicyService.getOpenChangesForPolicy(policyNumber);
            $scope.withdrawFormVisible = false;
            $scope.withdrawSuccessful = false;
            changePromise.then(function (res) {
                $scope.openChangePolicyEmpty = false;
                $scope.changePolicyData = res;
                if ($scope.changePolicyData == null || $scope.changePolicyData.length == 0) {
                    $scope.openChangePolicyEmpty = true;
                    $scope.showWithdrawForm();
                }
            });
            /**
            * Function to display withdraw form
            * @params{None}
            * @returns{boolean} - sets withdrawFormVisible to true
            * @private
            **/
            $scope.showWithdrawForm = function () {
                $scope.withdrawFormVisible = true;
            };
            /**
            * Function to withdraw a transaction based on Jobjumber
            * @params{String} - jobNumber
            * @returns{Object} - Modal window that gives user the option to select Yes or no. If Yes, then withdrawPolicyTransaction executed.
            * @private
            **/
            $scope.withdraw = function (jobNo) {
                var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this policy change?', '', 'Withdraw', '', 'Cancel').result;
                withdrawModal.then(function (res) {
                    var withdrawPromise = PolicyService.withdrawPolicyTransaction(policyNumber, jobNo);
                    withdrawPromise.then(function (res) {
                        $scope.$emit("withdrawSubmitted");
                    });
                });
            };
            /**
            * Function that allows user to continue and proceed with PolicyChange
            * @params{String, String, String, String, String} - jobNo,effDate,desc,preempted,status
            * @returns{Object} - new view either a New Policy Change or Preemption view
            * @private
            **/
            $scope.continuePolicyChange = function (jobNo, effDate, desc, preempted, status) {
                if (!preempted) {
                    $state.go('newPolicyChange', {
                        policyNumber: policyNumber,
                        data: desc,
                        jobNumber: jobNo,
                        effDate: effDate,
                        status: status
                    });
                } else {
                    $state.go('preemption', {
                        policyNumber: policyNumber,
                        data: desc,
                        jobNumber: jobNo,
                        effDate: effDate
                    });
                }
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/ChangePolicyDirective/ChangePolicy.js
// module id = 1732
// module chunks = 0